import { CustomRegistry } from "@nemuru-eng/js-api-client";
import { useContext, useMemo } from "react";
import { useTranslation } from "../../../../../../utils/hooks/useTranslation";
import { ConfigContext } from "../../../../../../contexts/ConfigContext";

export const useGetCustomerSupportDynamicDataTextsByRegistry = (registry) => {
  const { getTextIdTranslation } = useTranslation();
  const {
    state: { language },
  } = useContext(ConfigContext);

  const customerSupportDynamicDataTexts = useMemo(() => {
    switch (registry) {
      case CustomRegistry.CAIXABANK:
      case CustomRegistry.FACILITEA:
      case CustomRegistry.TESLA:
        return ["900 101 601", getTextIdTranslation("SUNDAY"), "9:00", "23:00"];
      default:
        null;
    }
  }, [registry, language]);

  return { customerSupportDynamicDataTexts };
};
